// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'

import styles from './ScoreChip.module.scss'

export const ScoreChip = ({ score, size, theme, className }) => (
  <Box
    align="center"
    ariaLabel={score}
    ariaRole="presentation"
    className={cx(styles.chip, styles.size, styles.theme, {
      [styles[size]]: Boolean(size),
      [styles[theme]]: Boolean(theme),
      [className]: Boolean(className),
    })}
    justify="center"
    tagName="span"
  >
    {score}
  </Box>
)
